import * as React from 'react';

import ResponseTimeInfo from 'components/response-time-info/ResponseTimeInfo';
import type { ResponseTime } from 'types';

import './creator-response-time.scss';

interface CreatorProfileAlike {
  isLightweight?: boolean
}

type Props<T> = {
  responseTime: ResponseTime | undefined | null,
  creatorProfile: T
};

const CreatorResponseTime = <T extends CreatorProfileAlike>(
  {
    responseTime,
    creatorProfile
  }: Props<T>
) => (
  <div className="creator-response-time">
    <ResponseTimeInfo
      responseTime={responseTime}
      creatorProfile={creatorProfile}
      isForCreator
    />
  </div>
  );

export default CreatorResponseTime;
